import {
  takeLatest,
  put,
  select,
  all,
  takeEvery,
} from 'redux-saga/effects';
import { message } from 'antd';
import { getDimensionData } from '@api/dimensionContainer';
import { autoRequest } from '@api/createArrayRequestStore';
import { originalDimensionsSelector, dimensionsSelector, payloadsSelector } from './selectors';
import * as types from './types';
import * as actions from './actions';

function* initRequests() {
  const originalDimensions = yield select(originalDimensionsSelector);
  const dimensions = yield select(dimensionsSelector);

  if (originalDimensions.length === 0) {
    yield put({
      type: types.SET_DIMENSIONS,
      dimensions,
    });
    yield put(actions.initAllRequests(dimensions.length));
  } else {
    yield put(actions.initAllRequests(originalDimensions.length));
  }
}

function* fetching() {
  const payloads = yield select(payloadsSelector);
  yield all(
    payloads.map((payload, index) => put(actions.fetching(index))),
  );
  try {
    yield all(
      payloads.map((payload, index) => autoRequest(index, getDimensionData, types.SCOPE, payload)),
    );
  } catch (error) {
    yield all(
      payloads.map((payload, index) => put({
        ...actions.fetchingFail(),
        index,
        errorCode: 500,
        errorMsg: 'Unknown Error',
      })),
    );
    message.error(error.message || 'Unknown error!');
  }
}

function* setDimension(action) {
  const payloads = yield select(payloadsSelector);
  const { index } = action;
  yield put(actions.initRequest(index));
  yield put(actions.fetching(index));
  try {
    yield autoRequest(index, getDimensionData, types.SCOPE, payloads[index]);
  } catch (error) {
    yield put(actions.fetchingFail(index, 500, 'Unknown Error'));
  }
}

function* switchDimension(action) {
  const { index, target } = action;
  yield put(actions.switchRequest(index, target));
}

function* watchInitRequests() {
  yield takeLatest([
    types.INIT_REQUESTS,
  ], initRequests);
}

function* watchFetching() {
  yield takeLatest([
    types.START_FETCHING,
  ], fetching);
}

function* watchSetDimension() {
  yield takeLatest([
    types.SET_DIMENSION,
  ], setDimension);
}

function* watchRefreshDimension() {
  yield takeEvery([
    types.REFRESH_DIMENSION,
  ], setDimension);
}

function* watchSwitchDimension() {
  yield takeLatest([
    types.SWITCH_DIMENSION,
  ], switchDimension);
}

export default [
  watchInitRequests,
  watchFetching,
  watchSetDimension,
  watchSwitchDimension,
  watchRefreshDimension,
];
